// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"5b76bb93","494":"7726353c","514":"279073dd","592":"219798e6","807":"003653bb","855":"7303fd38"}[chunkId] + ".css";
};